import type { Dispatch } from "redux";

import { navigationConstants } from "./types";
import ActionCreator from "utils/actionHandler";

export const setTab = (
  tabObject: string,
  tabValue?: string,
  topicId?: string
) => {
  return (dispatch: Dispatch) => {
    const tab = {
      tabObject,
      tabValue,
      topicId,
    };
    const actionCreator = new ActionCreator<typeof tab>(
      navigationConstants.NAVIGATION_SET_TAB
    );

    dispatch(actionCreator.request());

    try {
      dispatch(actionCreator.success(tab));
    } catch (error) {
      console.log("setTab Error: " + String(error));
      dispatch(actionCreator.failure(error));
    }
  };
};

export const setCompany = (companyId: string, companyName?: string) => {
  return (dispatch: Dispatch) => {
    const company = {
      companyId,
      companyName,
    };
    const actionCreator = new ActionCreator<typeof company>(
      navigationConstants.NAVIGATION_SET_COMPANY
    );

    dispatch(actionCreator.request());

    try {
      dispatch(actionCreator.success(company));
    } catch (error) {
      console.log("setCompany Error: " + String(error));
      dispatch(actionCreator.failure(error));
    }
  };
};
